type Props = {
  children: React.ReactNode;
  tone?: "accent" | "muted";
  className?: string;
};

/** Small uppercase, tracked section label (e.g. "FEATURED", "HOW IT WORKS"). */
export const Eyebrow = ({
  children,
  tone = "accent",
  className = "",
}: Props) => (
  <p
    className={`font-heading text-xs font-bold uppercase tracking-[0.15em] ${
      tone === "accent" ? "text-accent" : "text-text-light"
    } ${className}`}
  >
    {children}
  </p>
);
